import { useEffect, useState } from "react";
import api, { tokens } from "../services/api";

/**
 * Who am I.
 *
 * GET /api/me/ answers with the account the token belongs to. A 401 here means
 * the session is unrecoverable -- the interceptor in api.js has already tried
 * to refresh and failed -- so the only useful thing left is to end it.
 */
export const useUser = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tokens.access) {
      setLoading(false);
      return;
    }
    let live = true;
    api
      .get("/me/")
      .then((res) => live && setUser(res.data))
      .catch(() => {
        tokens.clear();
        window.location.href = "/sign-in";
      })
      .finally(() => live && setLoading(false));
    return () => {
      live = false;
    };
  }, []);

  return { user, loading };
};
